module.exports = __webpack_public_path__ + "img/SG-logo2.3a370d9b.svg";